import { RxCross2 } from "react-icons/rx";
import { TiTick } from "react-icons/ti";

const CustomSwitch = ({ isActive, onClick }) => {
  return (
    <div
      onClick={onClick}
      className={` min-w-[36px] w-[36px] h-5 rounded-[12px] relative transition-all duration-300 ease-linear cursor-pointer 
        ${
          isActive
            ? "bg-[#00FF8F] hover:bg-[#B6FFDF]"
            : "bg-[#C4C4C4] hover:bg-[#B6FFDF]"
        }`}
    >
      <div
        className={`absolute top-1/2 -translate-y-1/2 w-[16px] h-[16px] bg-white rounded-full transition-all duration-300 ease-in-out flex items-center justify-center p-[2px] [box-shadow:0_1px_2px_0_#1018280F,0_1px_3px_0_#1018281A] ${
          isActive ? "left-[calc(100%-19px)]" : "left-[3px]"
        }`}
      >
        {isActive ? (
          <TiTick color={"#21005D"} width="10px" height="6.5px" />
        ) : (
          <RxCross2 color="#21005D" width={12} height={12} strokeWidth={2} />
        )}
      </div>
    </div>
  );
};

export default CustomSwitch;
